import { RECRUITER_SITE_ORIGIN, resolveSiteOrigin } from '@/lib/publicDomain';

/** Canonical site origin for SEO (canonical, OG). Prefer {@link resolveSiteOrigin} at runtime. */
export const SITE_ORIGIN = RECRUITER_SITE_ORIGIN;

/** Default share image — 1200×630 PNG in public/brand/ */
export const DEFAULT_OG_IMAGE = `${RECRUITER_SITE_ORIGIN}/brand/og-default.png`;

export { resolveSiteOrigin };

export const NOINDEX_FOLLOW = 'noindex, follow' as const;
export const INDEX_FOLLOW = 'index, follow' as const;
